import React from "react";
import groupBy from "lodash/groupBy";
import ReportGroup from "./reportGroup";
import IReport from "../interfaces/IReport";
import { parseDateToDateString } from "../common/dateOperations";

export interface IReportListProps {
    items: IReport[];
}

const ReportList: React.FunctionComponent<IReportListProps> = ({ items }) => {
    const groups = groupBy(items, (x: IReport) => parseDateToDateString(x.start));
    return (
        <>
            {Object.entries(groups).map(([key, value]) => <ReportGroup key={key} items={value} />)}
        </>
    );
};

export default ReportList;
